import type { PortalLocale } from '@worldcoo/monolith/portals';

/**
 * The locales the redesigned site PUBLISHES, and the single source for that set: the language
 * switcher's labels, the `hreflang` alternates, the slug maps and the router's rewrite all read it,
 * so what the site advertises cannot drift from what it serves.
 *
 * DELIBERATELY five where `portalLocales` has ten and `www` offers four. French is published here
 * only — its catalog has been complete for a while and the Figma hand-off ships localised assets in
 * es/en/it/fr/ca. What gates the remaining five (de, eu, gl, nl, pt) is review and support, not
 * missing strings: `lingui compile --strict` already enforces a complete catalog for every locale.
 * Publishing one is therefore a one-line change here.
 *
 * ORDER IS LOAD-BEARING. `buildAlternatesWithSlugs` takes the first entry as `x-default`, which has
 * to be the locale the PATHLESS url actually serves, and `detectLocale` falls back to `es`. Spanish
 * first is correct — do not sort this.
 *
 * A plain module with no JSX on purpose: `router.tsx` reads it, and importing the switcher would drag
 * the flag components into the router's chunk.
 */
export const newLocales = ['es', 'en', 'ca', 'fr', 'it'] as const satisfies readonly PortalLocale[];

export type NewLocale = (typeof newLocales)[number];
